import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext(null);
// Dinamik API URL — hangi domain'den çalışırsa oraya bağlanır
const API = `${window.location.origin}/api`;

// Global axios interceptor for 401
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => {
    const t = localStorage.getItem("token");
    // Bozuk token temizle
    if (!t || t === "undefined" || t === "null") {
      localStorage.removeItem("token");
      return null;
    }
    return t;
  });
  const [user, setUser] = useState(null);

  const login = async (username, password) => {
    const res = await axios.post(`${API}/auth/login`, { username, password });
    // Eğer 2FA gerekiyorsa token kaydetme, login page yönetsin
    if (res.data.requires_2fa) {
      return res.data;  // token kaydedilmeden döndür
    }
    const { token: newToken, username: uname } = res.data;
    localStorage.setItem("token", newToken);
    setToken(newToken);
    setUser({ username: uname });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
  };

  useEffect(() => {
    if (token) {
      axios
        .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => setUser({ username: res.data.username }))
        .catch(() => logout());
    }
  }, []); // eslint-disable-line

  return (
    <AuthContext.Provider value={{ token, user, login, logout, isAuthenticated: !!token && token !== "undefined" }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
